import InteractiveMap, { MapItem, LegendItem } from "./InteractiveMap";

const ITEMS: Array<MapItem> = [
    { type: 'Fusebox', id: 'fusebox1', x: 229, y: 430 },
    { type: 'Tarot Cards', id: 'tarot', x: 350, y: 252 },
    { type: 'Voodoo Doll', id: 'voodoo', x: 350, y: 252 },
    { type: 'Monkey Paw', id: 'monkey', x: 350, y: 252 },
    { type: 'Haunted Mirror', id: 'mirror', x: 350, y: 252 },
    { type: 'Summoning Circle', id: 'circle', x: 350, y: 252 },
    { type: 'Music Box', id: 'musicbox', x: 350, y: 252 },
    { type: 'Ouija Board', id: 'ouija', x: 350, y: 252 },
];

const LEGEND: Array<LegendItem> = [
    { type: 'Fusebox', x: 547, y: 435 },
    { type: 'Tarot Cards', x: 547, y: 448 },
    { type: 'Voodoo Doll', x: 547, y: 463 },
    { type: 'Monkey Paw', x: 547, y: 477 },
    { type: 'Haunted Mirror', x: 547, y: 504 },
    { type: 'Summoning Circle', x: 547, y: 519 },
    { type: 'Music Box', x: 547, y: 534 },
    { type: 'Ouija Board', x: 547, y: 546 },
];

export default function SunnyMeadowsFemaleWing() {
    return <InteractiveMap filename="maps/Sunny_Meadows_Restricted_Map_-_Female_Wing_Floorplan.webp" width={1000} height={666} items={ITEMS} legend={LEGEND} />;
}
